<template>
  <div>
    <v-btn fab bottom right color="accent" fixed @click.stop="dialog = !dialog">
      <v-icon>add</v-icon>
    </v-btn>
    <v-dialog v-model="dialog" fullscreen transition="dialog-bottom-transition">
      <v-card>
        <v-card-title class="grey lighten-4 py-4 title black--text">Create New Coupon</v-card-title>
        <v-card-text>
          <v-form v-model="Form.valid">
            <v-container grid-list-xs :class="$vuetify.breakpoint.mdAndUp ? 'pa-5' : ''">
              <v-layout wrap>
                <v-flex xs12 md6>
                  <v-text-field
                    type="text"
                    label="Code"
                    v-model="Form.code"
                    mask="NNNNNNNNN"
                    v-validate="'checkUpperCaseAndNumber|min:3|required'"
                    :error-messages="errors.collect('code')"
                    data-vv-name="code"
                    hint="** If you would like to create your custom Coupon Code ( least 3 Characters A-Z 0-9 ) **"
                    persistent-hint
                  />
                </v-flex>
                <v-flex xs12 md5 offset-md1>
                  <v-text-field
                    label="Description"
                    v-model="Form.description"
                    auto-grow
                    v-validate="'required'"
                    :error-messages="errors.collect('description')"
                    data-vv-name="description"
                    clearable
                  />
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    label="Terms link url"
                    v-model="Form.terms_link_url"
                    auto-grow
                    data-vv-name="terms_link_url"
                    clearable
                  />
                </v-flex>
                <v-flex xs12>
                  <v-layout row wrap>
                    <v-flex xs12 md6>
                      <v-radio-group label="Discount Type" mandatory v-model="Form.discount_unit" row>
                        <v-radio label="Percentage" value="percentage" />
                        <v-radio label="Amount" value="amount" />
                      </v-radio-group>
                    </v-flex>
                    <v-flex xs12 md5 offset-md1>
                      <v-radio-group label="Applicable to" mandatory v-model="Form.type" row>
                        <v-radio label="Both" value="normal" />
                        <v-radio label="60-mins" value="session_60min" />
                        <v-radio label="30-mins" value="session_30min" />
                      </v-radio-group>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    type="text"
                    label="Discount"
                    v-validate="discountValidation"
                    :error-messages="errors.collect('discount_amount')"
                    data-vv-name="discount_amount"
                    v-model="Form.discount_amount"
                    :prefix="Form.discount_amount === 'percentage' ? '%' : '฿'"
                  />
                </v-flex>
                <v-flex xs12 md5 offset-md1>
                  <v-text-field
                    type="number"
                    label="Discount Limit"
                    v-validate="'min_value:1|required'"
                    :error-messages="errors.collect('discount_limit')"
                    data-vv-name="discount_limit"
                    v-model="Form.discount_limit"
                  />
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    type="number"
                    label="Total usage limit"
                    v-validate="'numberWithInfinity|required'"
                    :error-messages="errors.collect('total_usage_limit')"
                    data-vv-name="total_usage_limit"
                    v-model="Form.total_usage_limit"
                    hint="** -1 is Unlimited **"
                    persistent-hint
                  />
                </v-flex>
                <v-flex xs12 md5 offset-md1 mb-4>
                  <v-text-field
                    type="number"
                    label="Individual usage limit"
                    v-validate="'numberWithInfinity|required'"
                    :error-messages="errors.collect('individual_usage_limit')"
                    data-vv-name="individual_usage_limit"
                    v-model="Form.individual_usage_limit"
                    hint="** -1 is Unlimited **"
                    persistent-hint
                  />
                </v-flex>
                <v-flex xs12 md2 mb-8>
                  <v-select
                    v-model="Form.refresh_quota"
                    :items="refreshQuotaOptions"
                    label="Refresh quota"
                    :error-messages="errors.collect('refresh_quota')"
                    data-vv-name="refresh_quota"
                  />
                </v-flex>
                <v-flex xs12 md10> </v-flex>

                <v-flex xs12 md6>
                  <v-menu
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    max-width="480px"
                    min-width="480px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-on="on"
                        v-model="Form.promotion_start_at"
                        label="Promotaion start at"
                        prepend-inner-icon="access_time"
                        readonly
                        class="mb-1"
                      />
                    </template>
                    <VueCtkDateTimePicker
                      label="promotion start at"
                      v-model="Form.promotion_start_at"
                      locale="en"
                      time-format="HH:MM"
                      format="DD-MM-YYYY HH:mm"
                      inline
                      no-keyboard
                      no-button-now
                    />
                  </v-menu>
                </v-flex>

                <v-flex xs12 md5 offset-md1>
                  <v-menu
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    max-width="480px"
                    min-width="480px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-on="on"
                        v-model="Form.promotion_end_at"
                        label="Promotion end at"
                        prepend-inner-icon="access_time"
                        readonly
                        class="mb-1"
                      />
                    </template>
                    <VueCtkDateTimePicker
                      label="promotion end at"
                      v-model="Form.promotion_end_at"
                      locale="en"
                      time-format="HH:MM"
                      format="DD-MM-YYYY HH:mm"
                      inline
                      no-button-now
                      no-keyboard
                    />
                  </v-menu>
                </v-flex>

                <v-flex xs12 md6 class="add-tags-coupon">
                  <vue-tags-input
                    v-model="tag"
                    :allow-edit-tags="true"
                    :add-only-from-autocomplete="true"
                    :tags="selectedTags"
                    :autocomplete-items="filteredTags"
                    @tags-changed="(newTags) => (selectedTags = newTags)"
                  />
                </v-flex>

                <v-flex xs12>
                  <v-data-table
                    :headers="headers"
                    :items="Form.meta"
                    class="full-width full-height"
                    show-select
                    v-model="selectedMeta"
                  >
                    <template v-slot:top>
                      <v-toolbar flat color="white">
                        <v-toolbar-title>Meta</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical />
                        <CreateCouponMeta @clicked="createMeta" :FormDefault="Form.$data" />
                        <v-card-actions>
                          <v-btn color="error" v-if="selectedMeta.length > 0" @click="deleteMetaSelected()"
                            >Delete Selected</v-btn
                          >
                        </v-card-actions>
                      </v-toolbar>
                    </template>

                    <template v-slot:item.action="{ item }">
                      <v-icon small color="error" class="mr-2" @click="deleteMeta(item)">delete</v-icon>
                    </template>
                  </v-data-table>
                </v-flex>

                <v-flex>
                  <v-card-actions class="create-coupon-bt">
                    <v-btn color="danger" @click="closeDialog">Cancel</v-btn>
                    <v-btn color="accent" :disabled="!Form.valid" @click="confirmToCreate">Create</v-btn>
                  </v-card-actions>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<style>
.create-coupon-bt {
  position: fixed;
  right: 65px;
  bottom: 20px;
}

.add-tags-coupon {
  display: flex;
}

.add-tags-bt {
  margin: 18px;
}

.vue-tags-input {
  font-size: 16px;
  width: 100%;
  max-width: none !important;
}

.vue-tags-input .ti-input {
  border: 1px solid #9e9f9e;
  height: 50px;
  padding: 7px 0;
  border-radius: 3px;
}

.vue-tags-input .ti-autocomplete {
  border-radius: 0 0 6px 6px;
  padding: 10px;
}
</style>

<script>
import Forms from '../form/form';
import formMixin from '../Mixins/form';
import moment from 'moment';
import loader from '../utils/loader';
import * as R from 'ramda';
import couponService from '../services/coupon';
import tagsService from '../services/tags';
import dateUtil from '../utils/dateTime';
import couponTransformer from '../transformers/coupon';
import countryMixin from '../Mixins/country';
import VueTagsInput from '@johmun/vue-tags-input';

export default {
  mixins: [formMixin, countryMixin],
  data() {
    const currentTime = moment().format('DD-MM-YYYY HH:mm');
    this.getTagsList();
    return {
      dialog: false,
      tag: '',
      tagItems: [],
      selectedTags: [],
      selectedMeta: [],
      Form: new Forms({
        data: () => ({
          code: null,
          description: null,
          total_usage_limit: null,
          individual_usage_limit: null,
          discount_amount: null,
          discount_limit: null,
          type: null,
          discount_unit: 'percentage',
          terms_link_url: null,
          promotion_start_at: currentTime,
          promotion_end_at: currentTime,
          refresh_quota: null,
          tags: [],
          meta: [],
        }),
        transformToPayload: couponTransformer.create,
      }),
      headers: [
        { text: 'Total usage limit', value: 'total_usage_limit' },
        { text: 'Individual usage limit', value: 'individual_usage_limit' },
        { text: 'Discount amount', value: 'discount_amount' },
        { text: 'Discount limit', value: 'discount_limit' },
        { text: 'Discount unit', value: 'discount_unit' },
        { text: 'Terms link url', value: 'terms_link_url' },
        { text: 'Promotion start at', value: 'promotion_start_at' },
        { text: 'Promotion end at', value: 'promotion_end_at' },
        { text: 'Currency', value: 'currency' },
        { text: 'action', value: 'action' },
      ],
      refreshQuotaOptions: [
        {
          text: 'None',
          value: null,
        },
        {
          text: 'Daily',
          value: 'daily',
        },
        {
          text: 'Weekly',
          value: 'weekly',
        },
        {
          text: 'Monthly',
          value: 'monthly',
        },
        {
          text: 'Yearly',
          value: 'yearly',
        },
      ],
    };
  },

  computed: {
    haveCode() {
      if (this.Form.code) {
        return true;
      } else return false;
    },
    computedDateFormatted() {
      return dateUtil.formatDate(this.Form.date);
    },
    discountValidation() {
      let validateRule = {
        numeric: true,
        required: true,
      };
      if (this.Form.discount_unit === 'percentage') {
        validateRule.max_value = 100;
      }
      return validateRule;
    },

    filteredTags() {
      return this.tagItems
        .filter((a) => {
          return a.name.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1;
        })
        .map((a) => ({
          id: a.id,
          text: a.name,
        }));
    },
  },

  watch: {
    haveCode(val) {
      if (val) {
        this.Form.quantity = 1;
      } else {
        this.Form.limit = 1;
      }
    },
    selectedTags(tags) {
      this.Form.tags = tags.map((tag) => tag.id);
    },
    computedDateFormatted() {
      const endOfDay = moment().endOf('day').format('HH:mm');
      if (!moment().startOf('hour').add(4, 'hours').isSame(this.Form.date, 'day')) {
        this.Form.time = endOfDay;
      } else {
        this.Form.time = this.minTime;
      }
    },
  },

  methods: {
    dateUnix(time) {
      return moment(`${time} +07:00`, 'DD-MM-YYYY HH:mm Z').unix();
    },

    createMeta(value) {
      this.Form.meta.push({
        _id: this.Form.meta.length + 1,
        total_usage_limit: value.total_usage_limit,
        individual_usage_limit: value.individual_usage_limit,
        discount_amount: value.discount_amount,
        discount_limit: value.discount_limit,
        discount_unit: value.discount_unit,
        terms_link_url: value.terms_link_url,
        promotion_start_at: value.promotion_start_at,
        promotion_end_at: value.promotion_end_at,
        currency: value.currency,
      });
    },

    deleteMeta(item) {
      this.$root
        .$confirm('Delete', 'Are you sure for deleting ?', {
          color: 'error',
        })
        .then((confirm) => {
          if (confirm) {
            const { meta } = this.Form.$data;
            const filteredMeta = meta.filter((metaItem) => metaItem._id !== item._id);
            this.Form.meta = filteredMeta.map((meta, index) => ({
              ...meta,
              _id: index,
            }));
          }
        });
    },

    deleteMetaSelected() {
      this.$root
        .$confirm('Delete', 'Are you sure for deleting ?', {
          color: 'error',
        })
        .then((confirm) => {
          if (confirm) {
            const { meta } = this.Form.$data;
            const filteredMeta = meta.filter((metaItem) => {
              const result = this.selectedMeta.filter((selectedItem) => selectedItem._id === metaItem._id);
              return !(result.length > 0);
            });
            this.Form.meta = filteredMeta.map((meta, index) => ({
              ...meta,
              _id: index,
            }));
            this.selectedMeta = [];
          }
        });
    },

    allowedStep: (m) => m % 10 === 0,

    confirmToCreate() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$root
            .$confirm('Create', 'Are you confirm to create?', {
              color: 'primary',
              submitText: 'Yes',
            })
            .then((confirm) => {
              if (confirm) this.createCoupon();
            });
        }
      });
    },
    closeDialog() {
      this.resetFormError(null, this.Form);
      this.Form.meta = [];
      this.Form.tags = [];
      this.selectedTags = [];
      this.dialog = false;
    },

    createCoupon() {
      const param = {
        code: this.Form.code,
        description: this.Form.description,
        total_usage_limit: this.Form.total_usage_limit,
        individual_usage_limit: this.Form.individual_usage_limit,
        discount_amount: this.Form.discount_amount,
        discount_limit: this.Form.discount_limit,
        discount_unit: this.Form.discount_unit,
        type: this.Form.type,
        terms_link_url: this.Form.terms_link_url,
        refresh_quota: this.Form.refresh_quota,
        tags: this.Form.tags,
        promotion_start_at: this.dateUnix(this.Form.promotion_start_at),
        promotion_end_at: this.dateUnix(this.Form.promotion_end_at),
        meta: this.Form.meta.map((metaItem) => ({
          ...R.omit(['_id'], metaItem),
          promotion_start_at: this.dateUnix(this.Form.promotion_start_at),
          promotion_end_at: this.dateUnix(this.Form.promotion_end_at),
        })),
      };
      couponService
        .create(param)
        .then(() => {
          this.dialog = false;
          this.$emit('success');
          this.$notify({
            title: 'Success',
            text: 'Coupon are created!!',
            type: 'success',
          });
          this.closeDialog();
        })
        .catch((error) => {
          console.error(error);
          this.$notify({
            title: 'Create Coupon Fail',
            text: error,
            type: 'error',
          });
        });
    },
    getTagsList() {
      return new Promise((resolve, reject) => {
        tagsService
          .getAll({ page: 1, per_page: 1000 })
          .then((result) => {
            this.tagItems = result;
            resolve(result);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },

  mounted() {},
  components: {
    CreateCouponMeta: loader.component('CreateCouponMeta'),
    VueTagsInput,
  },
};
</script>
